export default "__VITE_ASSET__CshanV_u__"